module.exports = __webpack_public_path__ + "img/bb_button_activity.5f9dec72.svg";